import React, { useRef } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import grupoTvService from '../../../../services/tvs/grupoTvService.js';
import { validacaoFormGrupo } from '../helpers/validacao';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function FormCadastrarGrupo({
    setRecarregarDataTable,
    setOpenModalCadastro
}) {
    const initialValues= { nome: '',
        url: '' };
    const mensagemToast = useRef(null);

    const cadastrarGrupo = async dadosForm => {
        try {
            const { nome, tempoExecucao } = dadosForm;
           
            const corpoDaRequisicao = {
                nome,                
                status: 1,
                tempoExecucao
            };
            const segundo = 3000;
            
            await grupoTvService.cadastrarGrupo(corpoDaRequisicao);
            
            setRecarregarDataTable(true);
            mostrarMensagemSucesso(mensagemToast,'Grupo cadastrado com sucesso!');
            setTimeout( () => setOpenModalCadastro(false), segundo) ;            
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Não foi possível cadastrar um grupo! Tente novamente mais tarde.');
            throw new Error(error);
        }
    };

    return (
        <>
            <Growl ref={mensagemToast} />
            <Formik            
                initialValues={initialValues}
                validationSchema={validacaoFormGrupo}
                onSubmit={cadastrarGrupo}
                
            >{() => (
                    <Form  className="form-wrapper">
                        <div className="content-wrapper">
                            <div className="form-item">
                                <div className="form-item-label">
                                    <label htmlFor="nome">Nome do Grupo</label>
                                </div>
                                <Field
                                    as={InputText}
                                    id="nome"
                                    name="nome"
                                    type="text"
                                    size={30}
                                    maxLength={60}
                                />
                                <div className="form-item-label">
                                    <label htmlFor="nome">Tempo de Execucao (Segundos)</label>
                                </div>
                                <Field
                                    as={InputText}
                                    id="tempoExecucao"
                                    name="tempoExecucao"
                                    type="number"                                    
                                />

                                <ErrorMessage
                                    className="error-message"
                                    name="nome"
                                    component="div"
                                />
                            </div>
                        
                        </div>
                        <div className="edit-button">
                            <Button
                                label="Cadastrar"
                                icon="pi pi-caret-right"
                                iconPos="right"                                
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}
